export default __webpack_public_path__ + "static/789-ba185ef43efe99dd761fc9d4203bb035.gif";